<template>
  <view class="m-col" :class="colClass" :style="colStyle">
    <slot></slot>
  </view>
</template>

<script setup>
import { inject, computed } from 'vue';

const props = defineProps({
  span: { type: [Number, String], default: 24 },
  offset: { type: [Number, String], default: 0 },
  push: { type: [Number, String], default: 0 },
  pull: { type: [Number, String], default: 0 },
  xs: { type: [Number, Object], default: undefined },
  sm: { type: [Number, Object], default: undefined },
  md: { type: [Number, Object], default: undefined },
  lg: { type: [Number, Object], default: undefined },
  xl: { type: [Number, Object], default: undefined }
});

const rowGutter = inject('rowGutter', computed(() => ({ x: 0, y: 0 })));

// 解析响应式属性（支持 :xs="8" 或 :xs="{span: 8, pull: 4}"）
const parseResponsive = (val) => {
  if (typeof val === 'number' || typeof val === 'string') return { span: Number(val) };
  if (typeof val === 'object' && val !== null) return val;
  return null;
};

// 动态生成 class 列表
const colClass = computed(() => {
  const classes = [`m-col-${props.span}`];
  if (props.offset) classes.push(`m-col-offset-${props.offset}`);
  if (props.push) classes.push(`m-col-push-${props.push}`);
  if (props.pull) classes.push(`m-col-pull-${props.pull}`);
  
  ['xs', 'sm', 'md', 'lg', 'xl'].forEach(size => {
    const config = parseResponsive(props[size]);
    if (config) {
      if (config.span) classes.push(`m-col-${size}-${config.span}`);
      if (config.offset) classes.push(`m-col-${size}-offset-${config.offset}`);
      if (config.push) classes.push(`m-col-${size}-push-${config.push}`);
      if (config.pull) classes.push(`m-col-${size}-pull-${config.pull}`);
    }
  });
  return classes;
});

// 根据 Gutter 动态设置 padding
const colStyle = computed(() => {
  const { x, y } = rowGutter.value;
  return {
    paddingLeft: `${x / 2}px`,
    paddingRight: `${x / 2}px`,
    paddingTop: `${y / 2}px`,
    paddingBottom: `${y / 2}px`
  };
});
</script>

<style lang="less" scoped>
.m-col {
  box-sizing: border-box;
  flex: 0 0 auto; 
}

// 调用全局注入的 Mixin 生成基础栅格
.generate-cols(24);

// 调用全局注入的 Mixin 生成响应式断点
@media (max-width: 767px) {
  .generate-responsive(xs);
}
@media (min-width: 768px) {
  .generate-responsive(sm);
}
@media (min-width: 992px) {
  .generate-responsive(md);
}
@media (min-width: 1200px) {
  .generate-responsive(lg);
}
@media (min-width: 1920px) {
  .generate-responsive(xl);
}
</style>